import styled from '@emotion/styled/macro';
import rem from '../../../utils/rem/rem';

interface StyledProps {
  errorText?: string;
}

export const Page = styled.div`
  padding: 0 ${rem(32)} ${rem(32)} ${rem(32)};
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RowWrapper = styled.div<StyledProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: ${({ errorText }) => (errorText !== '' ? 'flex-start' : 'flex-end')};
  gap: ${rem(16)} 20px;

  button {
    margin-top: ${({ errorText }) => (errorText !== '' ? rem(24) : rem(0))};
  }
`;

export const DropdownWrapper = styled.div<StyledProps>`
  width: ${rem(130)};
`;

export const InputWrapper = styled.div<StyledProps>`
  width: ${rem(130)};

  input {
    margin-bottom: ${rem(6)};
  }
`;